import Turbolinks from "turbolinks";

document.addEventListener("turbolinks:visit", function(event) {
    Turbolinks.clearCache();
});

document.addEventListener("DOMContentLoaded", function() {
    adjustFooter();
    updateVisit();
});

document.addEventListener("turbolinks:load", function() {
    var fbScript = document.createElement("script");
    fbScript.async = true;
    fbScript.defer = true;
    fbScript.nonce = 'oeRsYflw';
    fbScript.crossorigin = "anonymous";
    fbScript.src = "https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v21.0&appId=534700525879227";
    document.body.appendChild(fbScript);
    $('#loading').hide(); // Oculta el loading cuando la página se ha cargado completamente

    const bodyController = document.body.getAttribute('data-controller');
    let intervalId;
    // Verifica si estás en la página 'home'.
    if (bodyController === 'home') {
        let polygons = [];  // Array global para almacenar los polígonos agregados
        updateForecast();
        updateReport();
        const map = initializeMainMap(polygons);
        // Cargar marcadores iniciales para "Hoy"
        updateMarkers('today', map, polygons);
    }

    updateInterval(bodyController);

    if (bodyController === 'home' || bodyController === 'monitoring') {
        // Programar para ejecutarse cada 10 minutos
        intervalId = setInterval(() => updateInterval(bodyController), 600000); // 10 minutos = 600,000 ms

        // Detener actualizaciones si se navega fuera de la página
        document.addEventListener("turbolinks:before-render", function () {
            if (intervalId) {
                clearInterval(intervalId);
            }
        });
    }
});

function updateInterval(bodyController) {
    if (bodyController === 'home') {
        updateAlerts();
        updateAviso();
    }

    if (bodyController === 'home' || bodyController === 'monitoring') {
        updateStations();
    }

    return true;
}

function updateForecast() {
    const forecastContainer = document.getElementById('forecast-section-container');

    if (forecastContainer) {
        const stateId = forecastContainer.getAttribute('data-state-id');

        fetch(`/forecast_section?state_id=${stateId}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                eval(data); // Ejecuta el JS generado por Rails (stations_section.js.erb).
            })
            .catch(error => console.error('Error loading forecast:', error));
    }
}

function updateReport() {
    const reportContainer = document.getElementById('report-section-container');

    if (reportContainer) {
        const stateId = reportContainer.getAttribute('data-state-id');

        fetch(`/report_section?state_id=${stateId}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                eval(data); // Ejecuta el JS generado por Rails (stations_section.js.erb).
            })
            .catch(error => console.error('Error loading report:', error));
    }
}

function updateStations() {
    const stateContainer = document.getElementById('state-section-container');

    if (stateContainer) {
        const stateId = stateContainer.getAttribute('data-state-id');

        fetch(`/stations_section?state_id=${stateId}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                eval(data); // Ejecuta el JS generado por Rails (stations_section.js.erb).
            })
            .catch(error => console.error('Error loading stations:', error));
    }
}

function updateAlerts() {
    const alertsContainer = document.getElementById('alerts-container');

    if (alertsContainer) {
        const stateId = alertsContainer.getAttribute('data-state-id');

        fetch(`/alerts_index?state_id=${stateId}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                eval(data); // Ejecuta el JS generado por Rails (index.js.erb).
            })
            .catch(error => console.error('Error loading alerts:', error));
    }
}

function updateAviso() {
    const avisoContainer = document.getElementById('aviso-section-container');

    if (avisoContainer) {
        const stateId = avisoContainer.getAttribute('data-state-id');

        fetch(`/aviso_section?state_id=${stateId}`, {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                eval(data); // Ejecuta el JS generado por Rails (index.js.erb).
            })
            .catch(error => console.error('Error loading aviso:', error));
    }
}

function updateVisit() {
    const deviceId = getOrCreateDeviceId();
    fetch('/count_unique_visit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ device_id: deviceId }),
    });
}

function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
        deviceId = crypto.randomUUID(); // Generar un UUID
        localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
}

function adjustFooter() {
    window.addEventListener("resize", adjustFooterAux);
    window.addEventListener("load", adjustFooterAux);
}

function adjustFooterAux() {
    const footer = document.getElementById("footer");
    const bodyHeight = document.body.scrollHeight;
    const windowHeight = window.innerHeight;

    if (bodyHeight <= windowHeight) {
        footer.classList.add("fixed-footer");
    } else {
        footer.classList.remove("fixed-footer");
    }
}

function onMapClick(e) {
    // Obtener la posición central del mapa
    var city_id = e.target.options.id;
    var state = e.target.options.title;
    var popup = e.target.getPopup();
    var map = e.target._map;
    var center = e.target._map.getCenter();
    var mapHeight = map.getSize().y; // Altura del mapa en píxeles

    // Calcular la nueva latitud para posicionar el popup en la parte inferior
    var offsetLat = map.containerPointToLatLng([0, mapHeight * 0.9]).lat;
    center.lat = offsetLat;

    $.ajax({
        url: '/three_day_forecast',
        method: 'GET',
        data: { city_id: city_id },
        headers: {
            Accept: "text/html", // Asegura que Rails devuelva HTML
        },
        success: function (response) {
            popup.setLatLng(center); // Mueve el popup a la parte inferior del mapa
            var result = `<div class="badge bg-success-light text-dark w-100 mb-3 text-uppercase">${state}</div><br/>` + response
            popup.setContent(result);
            popup.openOn(map); // Asegúrate de que el popup se abra en el mapa
        },
        error: function (xhr, status, error) {
            console.log('Error al obtener el pronóstico:', error);
        }
    });
};

// Función para actualizar los marcadores en el mapa
function updateMarkers(day, map, polygons) {
    let allVisible = true; // Estado global para rastrear la visibilidad
    $.ajax({
        url: '/get_day_forecast',
        method: 'GET',
        data: { day: day },
        success: function (response) {
            // Eliminar todos los marcadores existentes
            map.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    map.removeLayer(layer);
                }
            });

            // Eliminar todos los polígonos existentes
            polygons.forEach(function(polygon) {
                map.removeLayer(polygon);
            });
            polygons.length = 0; // Vaciar el array de polígonos

            // Agregar nuevos marcadores
            response.forecasts.forEach(function(forecast) {
                var iconHtml = `
                            <div class="text-center bg-opacity-25 ${forecast.background_color} border border-2 ${forecast.border_color}" style="position: relative; width: 80px; border-radius: 40px; border: 2px solid; padding: 0px 2px 2px;">
                              <img src="${forecast.img}" alt="Forecast" class="img-fluid rounded-circle forecast-img" style="width: 50px; height: 50px; margin-bottom: 18px; margin-top: -15px;">
                              <div class="d-flex justify-content-center" style="position: absolute; bottom: -5px; width: 100%;">
                                  <div class="badge badge-primary m-0" style="font-size: 15px; background-color: #007bff; color: white;">${forecast.tmin}°C</div>
                                  <div class="badge badge-danger m-0" style="font-size: 15px; background-color: #dc3545; color: white;">${forecast.tmax}°C</div>
                              </div>
                            </div>
                          `;

                var customIcon = L.divIcon({
                    html: iconHtml,
                    className: '',
                    iconSize: [80, 80],
                    iconAnchor: [40, 40]
                });

                var marker = L.marker([forecast.lat, forecast.lng], { icon: customIcon, title: forecast.state, id: forecast.city_id });
                marker.bindPopup("Loading...");
                marker.addTo(map);
                marker.on('click', onMapClick);
            });

            // Agregar etiquetas de sector
            $('#sector_labels').html(
                response.alert_types.map(function(alert_type) {
                    return `<div class="d-flex align-content-start badge ${alert_type.level_class}">${alert_type.alert_type}</div>`;
                }).join('')
            );

            // Agregar los polígonos de sectores en el mapa
            response.sectors.forEach(function(sector) {
                var polygon = L.polygon(sector.polygon_coordinates, { color: sector.color });
                polygon.addTo(map);
                polygon.isVisible = true; // Inicialmente, todos los polígonos son visibles

                var labelContent = `
                              <strong>Tipo de Alerta:</strong> ${sector.alert_type} <br>
                              <strong>Desde:</strong> ${sector.from} <br>
                              <strong>Hasta:</strong> ${sector.to} 
                          `;
                polygon.bindPopup(labelContent);
                polygons.push(polygon); // Almacenar el polígono en el array
            });

            polygons.forEach(function (polygon) {
                polygon.on("click", function () {
                    if (allVisible) {
                        // Ocultar todos los demás polígonos
                        polygons.forEach(function (p) {
                            if (p !== polygon) {
                                map.removeLayer(p);
                                p.isVisible = false;
                            }
                        });
                        allVisible = false; // Actualizar el estado global
                    } else {
                        // Mostrar todos los polígonos
                        polygons.forEach(function (p) {
                            if (!p.isVisible) {
                                map.addLayer(p);
                                p.isVisible = true;
                            }
                        });
                        allVisible = true; // Actualizar el estado global
                    }
                });
            });
        },
        error: function (xhr, status, error) {
            console.log('Error al obtener el pronóstico:', error);
        }
    });
}

function initializeMainMap(polygons){
    var pos = [-23.4425, -58.4438];
    var map = L.map('map', {
        scrollWheelZoom: false, // Desactiva el zoom con la rueda del mouse
        dragging: false,        // Desactiva el arrastre del mapa con el mouse
        doubleClickZoom: false, // Desactiva el zoom con doble clic
        zoomControl: true       // Control de zoom habilitado
    }).setView(pos, 7);

    var southWest = L.latLng(-30, -63);
    var northEast = L.latLng(-19, -50);
    var bounds = L.latLngBounds(southWest, northEast);
    map.setMaxBounds(bounds);
    map.on('drag', function () {
        map.panInsideBounds(bounds, { animate: false });
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 9,
        minZoom: 5,
        attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
    }).addTo(map);

    var MoveButtonControl = L.Control.extend({
        options: {
            position: 'bottomleft'  // Cambia la posición a la esquina inferior izquierda
        },

        onAdd: function() {
            var div = L.DomUtil.create('div', 'btn-group btn-group-sm leaflet-bottom leaflet-left');
            div.style.pointerEvents = 'all';

            // Establecer estilo gris para los botones, similar a los botones de zoom
            div.style.backgroundColor = '#f8f9fa'; // Color gris claro similar al fondo de los botones de zoom

            // Crear los botones en el contenedor div con iconos de flechas
            var btnArriba = L.DomUtil.create('button', 'btn btn-light skip-loading', div);
            btnArriba.innerHTML = '<i class="bi bi-arrow-up"></i>';  // Icono de flecha hacia arriba (Bootstrap Icons)

            var btnIzquierda = L.DomUtil.create('button', 'btn btn-light skip-loading', div);
            btnIzquierda.innerHTML = '<i class="bi bi-arrow-left"></i>';  // Icono de flecha hacia la izquierda (Bootstrap Icons)

            var btnDerecha = L.DomUtil.create('button', 'btn btn-light skip-loading', div);
            btnDerecha.innerHTML = '<i class="bi bi-arrow-right"></i>';  // Icono de flecha hacia la derecha (Bootstrap Icons)

            var btnAbajo = L.DomUtil.create('button', 'btn btn-light skip-loading', div);
            btnAbajo.innerHTML = '<i class="bi bi-arrow-down"></i>';  // Icono de flecha hacia abajo (Bootstrap Icons)

            // Habilitar el cursor de "mano" y asegurar que los eventos de clic funcionen en los botones
            L.DomEvent.disableClickPropagation(div);  // Evitar que el mapa capture clics
            L.DomEvent.disableScrollPropagation(div); // Evitar que el scroll afecte el mapa

            // Agregar eventos de clic y usar el objeto `map` global
            L.DomEvent.on(btnArriba, 'click', function() { map.panBy([0, -100]); });
            L.DomEvent.on(btnIzquierda, 'click', function() { map.panBy([-100, 0]); });
            L.DomEvent.on(btnDerecha, 'click', function() { map.panBy([100, 0]); });
            L.DomEvent.on(btnAbajo, 'click', function() { map.panBy([0, 100]); });

            return div;
        }
    });

    // Añadir el control al mapa
    map.addControl(new MoveButtonControl());

    // Crear un control personalizado con un grupo de botones
    var ButtonGroup = L.Control.extend({
        onAdd: function(map) {
            var div = L.DomUtil.create('div', 'btn-group btn-sm btn-group-toggle');
            div.innerHTML = `
                    <button type="button" class="btn btn-outline-dark border border-primary active skip-loading" id="today-btn">Hoy</button>
                    <button type="button" class="btn btn-outline-dark border border-primary skip-loading" id="tomorrow-btn">Mañana</button>
                    <button type="button" class="btn btn-outline-dark border border-primary skip-loading" id="day-after-btn">Pasado Mañana</button>
                `;
            return div;
        }
    });

    map.addControl(new ButtonGroup({ position: 'topright' }));

    // Asignar eventos de click a los botones
    $('#today-btn').on('click', function() {
        $('#today-btn').button('toggle');
        $('#tomorrow-btn').removeClass('active');
        $('#day-after-btn').removeClass('active');
        updateMarkers('today', map, polygons);
    });

    $('#tomorrow-btn').on('click', function() {
        $('#today-btn').removeClass('active');
        $('#tomorrow-btn').button('toggle');
        $('#day-after-btn').removeClass('active');
        updateMarkers('tomorrow', map, polygons);
    });

    $('#day-after-btn').on('click', function() {
        $('#today-btn').removeClass('active');
        $('#tomorrow-btn').removeClass('active');
        $('#day-after-btn').button('toggle');
        updateMarkers('day_after_tomorrow', map, polygons);
    });
    return map;
}